import { budgetTypeList } from "@/types";
import { z } from "zod";

const schema = z
  .object({
    jobTitle: z
      .string({ required_error: "Project title is required" })
      .min(1, "Project title is required"),
    description: z.string().min(1, "Project description is required"),
    goals: z
      .string({
        required_error: "You must provide a summary of what you're looking for",
      })
      .min(1, "You must provide summary of what you're looking for"),
    deliverables: z.string().min(1, "Project deliverables is required"),
    matchCriteria: z.array(z.string()).length(3),
    scopeEngagementDuration: z.string().min(1, "Duration required"),
    idealStartDate: z.date({ required_error: "Ideal start date is required" }),
    budgetType: z.enum(budgetTypeList),
    budgetMinCents: z
      .number()
      .int()
      .min(1, { message: "A minimum budget is required" })
      .nullable()
      .refine((v) => v !== null, { message: "A minimum budget is required" }),
    budgetMaxCents: z
      .number()
      .int()
      .min(1, { message: "A maximum budget is required" })
      .nullable()
      .refine((v) => v !== null, { message: "A maximum budget is required" }),
    budgetNotes: z.string().optional(),
    additionalInformation: z.string().optional(),
  })
  .refine((data) => data.budgetMinCents <= data.budgetMaxCents, {
    message: "budgetMinCents must be less than or equal to budgetMaxCents",
    path: ["budgetMinCents"],
  });

type Schema = z.infer<typeof schema>;

export {
  schema as companyProjectFormSchema,
  type Schema as CompanyProjectFormSchema,
};
